import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Router navigation events for the application.
 *
 * These events track router state changes and navigation milestones.
 *
 * @example
 * const dispatch = injectDispatch(routerEvents);
 * dispatch.firstNavigationCompletedEvent();
 */
export const routerEvents = eventGroup({
  source: 'router',
  events: {
    firstNavigationCompletedEvent: type<void>(),

    navigationStarted: type<void>(),
    navigationEnded: type<{
      url: string;
    }>(),
    navigationError: type<{
      error: string;
    }>(),
  },
});
